import "./courses.scss";
type CoursesPageProps = {};

const Courses = (props: CoursesPageProps) => {
  return (
    <>
      <div className="courses page">
        <div className="courses__header page__header">
          <h1 className="courses__header__title page__header__title">
          КУРСОВЕ
          </h1>
        </div>
        <div className="courses__body">
          <h1 className="courses__body__title">
          V ПКС
          </h1>
          {/* <p className="courses__body__content">
            <strong>Удостоверение № С7 - 0000005803 /26-03-2023г. </strong>-
            ,,Най-новите информационни технологии в процеса на обучение” –
            Просвета –София АД - 1 кредит
          </p> */}
        </div>
      </div>
    </>
  );
};

export default Courses;
